import { useWalls } from './getWalls';

import { WallWindowRelations } from 'types';

const removeWallsWithoutFolders = (walls: WallWindowRelations[]) => {
  return walls.filter((wall) => !wall.folder_id);
};

type UseWallOptions = {
  userId: number;
};

export const useWallsWithoutFolders = ({ userId }: UseWallOptions) =>
  useWalls(userId, (data: WallWindowRelations[]) =>
    removeWallsWithoutFolders(data)
  );
